var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgRetake = function SvgRetake(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M20.95 12.947A9.001 9.001 0 0 1 3.835 15.79M3 20.053v-4.737h2.842M3.05 11.053a9 9 0 0 1 13.795-6.64 9 9 0 0 1 3.322 3.798M21 3.947v4.737h-2.842"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRetake);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;